import { render, staticRenderFns } from "./InfoLogo.vue?vue&type=template&id=7670677a&scoped=true&"
import script from "./InfoLogo.vue?vue&type=script&lang=js&"
export * from "./InfoLogo.vue?vue&type=script&lang=js&"
import style0 from "../../Style/info-logo.scss?vue&type=style&index=0&id=7670677a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670677a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7670677a')) {
      api.createRecord('7670677a', component.options)
    } else {
      api.reload('7670677a', component.options)
    }
    module.hot.accept("./InfoLogo.vue?vue&type=template&id=7670677a&scoped=true&", function () {
      api.rerender('7670677a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/ChangeInfo/InfoLogo.vue"
export default component.exports